import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Snackbar, Alert } from '@mui/material';
import PageHeader from '../components/common/PageHeader';
import UserForm from '../components/users/UserForm';
import { createUser } from '../services/userService';

const CreateUserPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      await createUser(formData);
      setSnackbar({
        open: true,
        message: 'User created successfully',
        severity: 'success',
      });
      setTimeout(() => navigate('/users'), 1500);
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Failed to create user';
      setSnackbar({ open: true, message: errMsg, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <PageHeader
        title="Create User"
        breadcrumbs={[
          { label: 'Users', link: '/users' },
          { label: 'Create' },
        ]}
      />

      <Paper sx={{ p: 3 }}>
        <UserForm onSubmit={handleSubmit} loading={loading} isEdit={false} />
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateUserPage;
